export const socialLinks = {
  github: "https://github.com/rusty-web3-developer/",
  linkedin: "https://www.linkedin.com/in/rusty-developer/",
  telegram: "https://t.me/solrusty1210",
  discord: "https://discord.com/users/568538156018958338",
};
